module.exports = __webpack_public_path__ + "img/winkAlimLogo.7a8295b1.png";